import React, { memo } from 'react'
import { Container } from './styles'
import Data from '../../data.json'
import { CardImg } from '../../pages/Game/GameCards/styles'

type CardProps = {
  children: React.ReactNode
  onClick: () => void
  isShowingFrontFace?: boolean
  isVisible?: boolean
  className?: string
  disabled?: boolean
}

const Card: React.FC<CardProps> = (props) => {
  const {
    children,
    onClick,
    isShowingFrontFace = false,
    isVisible = true,
    className,
    disabled = false,
  } = props

  return (
    <Container
      isVisible={isVisible}
      className={className}
      isShowingFrontFace={isShowingFrontFace}
      onClick={onClick}
      disabled={disabled}
    >
      {isShowingFrontFace ? children : <CardImg src={Data.cover.src} />}
    </Container>
  )
}

export default memo(Card)
